/**
 * @constructor
 */
export default function ParamContract(type, key, values, props) {
    this.type = type;
    this.key = key || '';
    this.values = values || [];
    this.props = props || {};
}
